import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clients: {},
  offlineLicenses: {},
  permanentLicenses: {},
  temporaryLicenses: {},
  trialLicenses: {},
  productReleases: {},
  productReleasesHistory: {},
  clientsHistory: {},
  offlineLicensesHistory: {},
  permanentLicensesHistory: {},
  temporaryLicensesHistory: {},
  trialLicensesHistory: {},
  accounts: {},
  accountsHistory: {},
  wrongActivationsHistory: {},
  webViewerServers: {},
  webViewerLicenses: {},
  trialSettingsHistory: {},
  bannedDevices: {},
  banHistory: {},
};

const paginationTables = createSlice({
  name: 'paginationTables',
  initialState,
  reducers: {
    setPaginationPage: (state, action) => {
      const { object, page, sizePerPage } = action.payload;
      state[object] = { page, sizePerPage };
    },
  },
});

const { reducer, actions } = paginationTables;

const { setPaginationPage } = actions;

export const setPagination = (object, page, sizePerPage) => (dispatch) => {
  return new Promise((resolve) => {
    dispatch(setPaginationPage({ object, page, sizePerPage }));
    resolve();
  });
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/userConfigs/paginationTablesSlice.js